// ####################################################################
// #                    MAIN SHOPPING FUNCTION JS FILE                #
// ####################################################################
export function increment(packType) {
    var input = document.getElementById("quantity-" + packType);
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;
    updateTotalPrice(packType);
}

function decrement(packType) {
    var input = document.getElementById("quantity-" + packType);
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value--;
    value = value < 1 ? 1 : value; // Ensure the quantity never goes below 1
    input.value = value;
    updateTotalPrice(packType);
}

export function updateTotalPrice(packType) {
    var quantity = document.getElementById("quantity-" + packType).value;
    var pricePerDay;
    switch (packType) {
        case "single":
            pricePerDay = 2.9;
            break;
        case "triple":
            pricePerDay = 2.61;
            break;
        case "fiveplusone":
            pricePerDay = 2.32;
            break;
        default:
            pricePerDay = 0;
    }
    var totalPrice;
    if (packType === "fiveplusone") {
        totalPrice = (quantity * pricePerDay * 30 * 5) / 5; // Fünferpackung Preisberechnung: 5 bezahlen, 1 geschenkt
    } else {
        totalPrice = quantity * pricePerDay * 30; // Assuming a monthly price calculation
    }
    document.getElementById("total-price-" + packType).innerText = totalPrice.toFixed(2) + " €";
}

export function addToCart(productId, packType, defaultQuantity) {
    var quantity = document.getElementById("quantity-" + packType).value || defaultQuantity;
    var csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
    if (!csrfTokenMeta) {
        // console.error("CSRF token meta tag not found");
        return;
    }
    var csrfToken = csrfTokenMeta.getAttribute("content");

    var payload = {
        lineItems: {
            [productId]: {
                quantity: parseInt(packType === "fiveplusone" ? 6 : quantity, 10), // 6 Artikel bei fiveplusone
                id: productId,
                type: "product",
                referencedId: productId,
                stackable: 1,
                removable: 1,
            },
        },
        product_name: "Mental Fit",
        brand_name: "Sanaponte GmbH",
        redirectTo: "frontend.cart.offcanvas",
    };

    fetch("/checkout/line-item/add", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrfToken,
        },
        body: JSON.stringify(payload),
    })
        .then((response) => {
            if (!response.ok) {
                return response.text().then((text) => {
                    throw new Error(text);
                });
            }
            return response.json();
        })
        .then((data) => {
            // console.log("Success:", data);
            // Aktualisiere das Warenkorbsymbol
            // fetch("/checkout/offcanvas")
            //   .then((response) => response.text())
            //   .then((html) => {
            //     document.querySelector(".js-offcanvas-cart-wrapper").innerHTML = html;
            //   });
        })
        .catch((error) => {
            // console.error("Error:", error.message);
            // console.log("Response received:", error);
        });
}

// ####################################################################
// #              CHECKPROMOCODE & OFFCANVAS OBERSERVER               #
// ####################################################################
export function onBlurPromotionAction() {
    const promoInput = document.getElementById("addPromotionInput");
    const promoButton = document.getElementById("addPromotion");

    if (promoInput && promoButton) {
        promoInput.addEventListener("blur", function () {
            if (promoInput.value.trim() !== "") {
                promoButton.click();
                promoButton.style.backgroundColor = "#9cc43d";
            } else {
                promoButton.style.backgroundColor = "#dbdbdb";
            }
        });
    } else {
        // console.warn("Promo-Input oder Promo-Button nicht gefunden.");
    }
}

export function onBlurCanvasPromotionAction() {
    // console.info("Function Call: CanvasPromotionAction inner FUNCTION");
    const promoCanvasButton = document.getElementById("addPromotionOffcanvasCart");
    const promoCanvasInput = document.getElementById("addPromotionOffcanvasCartInput");

    if (promoCanvasInput && promoCanvasButton) {
        // console.info("CANVAS Promo Input und Button gefunden.");
        promoCanvasInput.addEventListener("blur", function () {
            // console.info("Blur event ausgelöst.");
            if (promoCanvasInput.value.trim() !== "") {
                promoCanvasButton.click();
                promoCanvasButton.style.backgroundColor = "#9cc43d";
            } else {
                promoCanvasButton.style.backgroundColor = "#dbdbdb";
            }
        });
    } else {
        // console.warn("Promo-Input oder Promo-Button nicht gefunden.");
    }
}

export function observeOffcanvasElement() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.classList && node.classList.contains("offcanvas-body")) {
                    // console.info("Offcanvas-Element wurde hinzugefügt.");
                    onBlurCanvasPromotionAction();
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}